export default __webpack_public_path__ + "static/media/property_1015.c5fae6bc.png";